module.exports = __webpack_public_path__ + "media/images/training_bg_image-8c0e0ce16920d303a58fa336c899c4a8.png";